import { IErrorService } from '@microsoft/applicationinsights-angularplugin-js';
import { Injectable } from "@angular/core";

@Injectable()
export class PcpInsightsErrorHandler implements IErrorService {
    handleError(error: any) {
        // NOTE: logging errors to application insights in performed behind the scenes.
        //       Actions here will be performed _additionally_

        // Ignore ResizeObserver errors
        if (error.message && error.message.includes('ResizeObserver loop completed with undelivered notifications')) {
            // Ignore ResizeObserver errors
            return;
        }


        // The default AI ErrorHandler does not log errors to console.. let's do it here.
        console.error(error);
    }
}
